import * as React from "react";
import { forwardRef } from "react";
const SvgPlusThin = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.75 3a.75.75 0 0 0-1.5 0v4.25H3a.75.75 0 0 0 0 1.5h4.25V13a.75.75 0 0 0 1.5 0V8.75H13a.75.75 0 0 0 0-1.5H8.75z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPlusThin);
export default ForwardRef;
